import { useEffect } from 'react';
import useClientSelect from 'Modules/Plans/Clients/hooks/useClientSelect';

/**
 * A request belongs to one client, so the page and the global selection can only disagree by
 * accident — a link, a bookmark or a reload arriving under whichever client was last picked. The
 * request is the one that knows, so the selection follows it and the rest of the app comes along,
 * as it does on every other detail page.
 */
export default function useSyncSelectedClient(clientId: number | undefined) {
    const { selectedClientId, setSelectedClientId } = useClientSelect();

    useEffect(() => {
        // Until the request is in there is nothing to sync from, and an unset selection is one that
        // has yet to resolve rather than a client to correct.
        if (typeof clientId !== 'number' || typeof selectedClientId !== 'number') {
            return;
        }

        if (selectedClientId === clientId) {
            return;
        }

        setSelectedClientId(clientId);
    }, [clientId, selectedClientId, setSelectedClientId]);
}
